import api from './api';

/** Получить превью инвайта без вступления в комнату. */
export const getInvitePreview = async (code) => {
  const response = await api.get(`/api/invite/${code}/preview`);
  return response.data;
};

/** Создать инвайт-ссылку для комнаты. */
export const createInviteLink = async (roomId, data = {}) => {
  const response = await api.post(`/api/rooms/${roomId}/invite-links`, data);
  return response.data;
};

/** Получить все инвайт-ссылки комнаты. */
export const getInviteLinks = async (roomId) => {
  const response = await api.get(`/api/rooms/${roomId}/invite-links`);
  return response.data;
};

/** Деактивировать инвайт-ссылку. */
export const revokeInviteLink = async (roomId, linkId) => {
  await api.delete(`/api/rooms/${roomId}/invite-links/${linkId}`);
};

/** Вступить в комнату по инвайт-коду. */
export const joinByInviteCode = async (code) => {
  const response = await api.post(`/api/invite/${code}/join`);
  return response.data;
};
